import React, { FunctionComponent } from 'react';
import classnames from 'classnames';

import styles from './main.scss';

type BadgeProps = {
    children: React.ReactNode;
    type?: 'neutral' | 'alert' | 'link';
    size?: 'medium';
};

export const Badge: FunctionComponent<BadgeProps> = props => {
    const { children, type, size } = props;

    const badgeClasses = classnames(styles.badge, {
        [styles.badgeNeutral]: type === 'neutral',
        [styles.badgeAlert]: type === 'alert',
        [styles.badgeLink]: type === 'link',
        [styles.badgeMedium]: size === 'medium',
    });

    const badgeInnerClasses = classnames(styles.badgeInner, {
        [styles.badgeInnerMedium]: size === 'medium',
    });

    return (
        <div className={badgeClasses}>
            <div className={badgeInnerClasses}>{children}</div>
        </div>
    );
};
